import Link from '@mui/material/Link'
import { Trans, useTranslation } from 'react-i18next'

/** Warning: does not complain about missing namespace */
export const I18n: typeof Trans = (props) => {
	const { t } = useTranslation()
	return (
		<Trans
			t={t}
			components={{
				sup: <sup />,
				sub: <sub />,
				br: <br />,
				b: <b />,
				i: <i />,
				ul: <ul />,
				li: <li />,
				a: <Link underline='always' />,
				code: <code />,
			}}
			{...props}
		/>
	)
}
